module.exports = __webpack_public_path__ + "img/male_icon.25f3415e.svg";